import * as React from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';

interface AppLinkProps {
  role: 'primary' | 'secondary';
  to?: string;
  target?: string;
  href?: string;
  children: React.ReactNode;
  bold?: boolean;
  onClick?: any;
}

export const AppLink: React.FC<AppLinkProps> = ({
  role,
  to,
  target,
  href,
  children,
  bold,
  onClick,
  ...rest
}) => {
  const linkClassName = cn('link', `link--${role}`, {
    'link--bold': bold,
  });

  if (href) {
    return (
      <a href={href} target={target} className={linkClassName} {...rest}>
        {children}
      </a>
    );
  }

  if (to) {
    return (
      <Link
        onClick={onClick}
        to={to}
        target={target}
        className={linkClassName}
        {...rest}
      >
        {children}
      </Link>
    );
  }

  return null;
};
